export const selectOptionsCitizenshipStatus = [
  "US Citizen",
  "Foreign National with SSN",
  "Foreign National",
  "Foreign National Non-Resident",
  "Other - Options do not apply",
];
